
interface IContinueButtonProps {
  onClick?:
    | ((value?: boolean) => void)
    | ((isOpen: boolean, isSuccessMobile?: boolean | undefined) => void);
}

export default function ContinueButton({
  onClick,
}: IContinueButtonProps): JSX.Element {
  return (
    <div>
      <div className="fixed bottom-0 z-10 w-full rounded-t-2xl bg-white p-[10px]">
        <button
          onClick={() => {
            if (onClick) onClick(true);
          }}
          className="mx-auto flex w-[90%] justify-center rounded-full bg-orange p-[1.375rem] font-semibold text-white"
        >
          Continue
        </button>
      </div>
    </div>
  );
}
